export enum EOperationType {
  ORIGIN = "Origem",
  LOADING = "Carregamento",
  UNLOADING = "Descarregamento",
  DESTINATION = "Destino",
  REFUELING = "Abastecimento",
  DEALERSHIP = "Concessionária",
  REST = "Descanso",
  END_OF_WORKDAY = "Fim de Jornada de Trabalho",
  WEIGHING = "Pesagem",
  WAYPOINT = "Ponto de Passagem",
  PRF_ANTT_POST = "Posto PRF/ANTT",
  MEAL = "Refeição",
}

export interface ICsvData {
  zipCode: string;
  city: string;
  company: string;
  position: string;
  address: string;
  state: string;
  quantity: number;
  stopTime: string;
  operationType: EOperationType;
}